export const PUBLISHED = 'published';
export const UNPUBLISHED = 'unpublished';
export const LOCATIONS = 'locations';
export const INDUSTRIES = 'industries';
export const AREAS = 'areas';
